
const FOLLOWER_STORAGE_KEY = "cheerfully-followers";

function storeFirstFollowers(followerIds) {
    window.localStorage.setItem(FOLLOWER_STORAGE_KEY, JSON.stringify(followerIds));
}

/**
 * Allows you to store local follower ids to browser storage for id purposes
 *
 * @param {integer | array} followerIds
 */
export function storeLocalFollowers(followerIds) {
    if( ! window.localStorage || !followerIds) {
        return;
    }
    if(!Array.isArray(followerIds)) {
        followerIds = [followerIds];
    }
    let storedFollowers = window.localStorage.getItem(FOLLOWER_STORAGE_KEY);
    if(!storedFollowers) {
        return storeFirstFollowers(followerIds);
    }
    try {
        storedFollowers = JSON.parse(storedFollowers)
    } catch(e) {
        return storeFirstFollowers(followerIds);
    }
    if(!Array.isArray(storedFollowers) || storedFollowers.length === 0) {
        return storeFirstFollowers(followerIds);
    }
    let uniqueFollowerIds = followerIds.filter(id => {
        return storedFollowers.indexOf(id) < 0;
    });
    if(uniqueFollowerIds.length === 0) {
        return;
    }
    let updatedFollowers = [...storedFollowers, ...uniqueFollowerIds];
    window.localStorage.setItem(FOLLOWER_STORAGE_KEY, JSON.stringify(updatedFollowers));
}

/**
 * Gets an array of local followers saved to the browser
 *
 * @return {array}
 */
export function getLocalFollowers() {
    if(!window.localStorage) {
        return [];
    }
    let followers = window.localStorage.getItem(FOLLOWER_STORAGE_KEY);
    if(!followers) {
        return [];
    }
    try {
        followers = JSON.parse(followers);
    } catch(e) {
        window.localStorage.removeItem(FOLLOWER_STORAGE_KEY);
        return [];
    }
    if(!Array.isArray(followers)) {
        window.localStorage.removeItem(FOLLOWER_STORAGE_KEY);
        return [];
    }
    return followers;
}
